import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Button,
  Divider,
  Spinner,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { ArrowLeftIcon } from "@chakra-ui/icons";
import TeamActivityBreadcrumb from "../components/CareersComponents/TeamActivityComponents/TeamActivityBreadcrumb";
import TeamActivityHeroImage from "../components/CareersComponents/TeamActivityComponents/TeamActivityHeroImage";
import TeamActivityTitleSection from "../components/CareersComponents/TeamActivityComponents/TeamActivityTitleSection";
import TeamActivityContent from "../components/CareersComponents/TeamActivityComponents/TeamActivityContent";
import RelatedPosts from "../components/CareersComponents/TeamActivityComponents/RelatedPosts";
import { useBlogWithRelated } from "../hooks/useBlog";

const BlogDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  // Try to get blog post from location state first
  const initialBlogPost = location.state?.blogPost;
  const currentPage = location.state?.currentPage || 1;

  // Use the new hook to fetch blog with related posts from API
  const {
    blog: apiBlog,
    loading: apiLoading,
    error: apiError,
  } = useBlogWithRelated(id);

  // Determine which blog post to use
  const blogPost = apiBlog || initialBlogPost;
  const loading = apiLoading;
  const error = apiError;

  const handleCardClick = (post, idx) => {
    const postId = post.id || post.slug || idx + 1;
    navigate(`/newsroom-details/${postId}`, { state: { blogPost: post } });
  };

  // Special debug for potential problematic fields
  if (blogPost) {
    Object.keys(blogPost).forEach((key) => {
      // const value = blogPost[key];
      // Debug if needed
    });
  }

  // Loading state
  if (loading && !blogPost) {
    return (
      <Container maxW="7xl" py={8}>
        <Button
          leftIcon={<ArrowLeftIcon />}
          onClick={() => navigate(-1)}
          mb={4}
        >
          Back
        </Button>
        <Spinner size="xl" color="#000B8C" />
      </Container>
    );
  }

  // Error state
  if (error && !blogPost) {
    return (
      <Container maxW="7xl" py={8}>
        <Button
          leftIcon={<ArrowLeftIcon />}
          onClick={() => navigate(-1)}
          mb={4}
        >
          Back
        </Button>
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          {error}
        </Alert>
      </Container>
    );
  }

  // Blog not found
  if (!blogPost) {
    return (
      <Container maxW="7xl" py={8}>
        <Button
          leftIcon={<ArrowLeftIcon />}
          onClick={() => navigate(-1)}
          mb={4}
        >
          Back
        </Button>
        Blog post not found.
      </Container>
    );
  }

  return (
    <>
      <Container maxW="8xl">
        <TeamActivityBreadcrumb 
          fromWhere={"blog"} 
          currentPage={currentPage}
        />
        <Container maxW="7xl" >
          <TeamActivityTitleSection
            tag={
              typeof blogPost.tag === "object"
                ? blogPost.tag?.fullName || blogPost.tag?.name || "News"
                : blogPost.tag || "News"
            }
            title={blogPost.title}
            // author={
            //   typeof blogPost.author === "object"
            //     ? blogPost.author?.fullName || "BA Systems"
            //     : blogPost.author || "BA Systems"
            // }
            blogPost={blogPost}
          />
          <TeamActivityHeroImage
            image={blogPost.image}
            title={blogPost.title}
            isVideo={blogPost.isVideo}
            videoUrl={blogPost.videoUrl}
            images={blogPost.images || []}
          />

          {/* <Divider mb={6} /> */}
          <TeamActivityContent
            desc={blogPost.post_desc || blogPost.content || blogPost.desc}
            hashtags={
              Array.isArray(blogPost.hashtags)
                ? blogPost.hashtags.map((tag) =>
                    typeof tag === "object"
                      ? tag.name || tag.text || String(tag)
                      : String(tag)
                  )
                : blogPost.hashtags
                ? [String(blogPost.hashtags)]
                : []
            }
          />
          {blogPost.relatedPosts && blogPost.relatedPosts.length > 0 && (
            <RelatedPosts
              posts={blogPost.relatedPosts}
              onCardClick={handleCardClick}
            />
          )}
        </Container>
      </Container>
    </>
  );
};

export default BlogDetails;
